interface TeaserBubbleProps {
  message: string;
  onOpen: () => void;
  onDismiss: () => void;
}

export function TeaserBubble({ message, onOpen, onDismiss }: TeaserBubbleProps) {
  return (
    <div class="animate-teaserIn mb-3 max-w-[260px]">
      <div
        role="button"
        tabIndex={0}
        aria-label="Open chat"
        class="relative bg-[var(--background)] rounded-2xl shadow-[var(--card-shadow)] p-3.5 pl-4 cursor-pointer hover:shadow-[var(--card-shadow-hover)] transition-shadow border border-[var(--border)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
        onClick={onOpen}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOpen(); } }}
      >
        {/* Primary color accent bar */}
        <div class="absolute left-0 top-3 bottom-3 w-[3px] rounded-full bg-[var(--primary)]" />

        {/* Dismiss button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          class="absolute -top-2 -right-2 size-6 rounded-full bg-[var(--background)] border border-[var(--border)] shadow-sm flex items-center justify-center text-[var(--muted-foreground)] hover:text-[var(--foreground)] hover:border-[var(--foreground)]/20 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
          aria-label="Dismiss"
        >
          <svg
            class="size-3"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>

        {/* Message text — clamped to 3 lines */}
        <p class="text-[13px] leading-[1.4] text-[var(--foreground)] line-clamp-3 pr-2">
          {message}
        </p>
      </div>

      {/* Speech bubble pointer */}
      <div class="flex justify-end mr-7">
        <svg width="16" height="8" viewBox="0 0 16 8" class="drop-shadow-sm">
          <path
            d="M0 0 L8 8 L16 0"
            fill="var(--background)"
            stroke="var(--border)"
            stroke-width="1"
            stroke-linejoin="round"
          />
          {/* White fill to cover the border on the connecting edge */}
          <path d="M1 0 L8 7 L15 0" fill="var(--background)" />
        </svg>
      </div>
    </div>
  );
}
